import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=4904a045&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=4904a045&prod&scoped=true&lang=css"
import style1 from "./SubMenu.vue?vue&type=style&index=1&id=4904a045&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904a045",
  null
  
)

export default component.exports